const additional = {
  methods: {
    saveAdditional (adt) {
      if (this.$refs.SaveForm.validate()) {
        this.$store.dispatch('saveData', { page: 4, data: adt, item: this.id })
      }
    }
  }
}
export default additional
